import MasterCrudPage from '../../components/MasterCrudPage';

export default function LeaveGroups() {
  return (
    <MasterCrudPage
      config={{
        title: 'Leave Group',
        apiBase: '/lms/masters/leave-groups',
        listKey: 'leaveGroups',
        entityKey: 'leaveGroup',
        fields: [
          { key: 'nameCn', label: 'Name (Chinese)', type: 'text', maxLength: 50 },
          { key: 'nameMy', label: 'Name (Malay)', type: 'text', maxLength: 50 },
          {
            key: 'applicationMethod',
            label: 'Application Method',
            type: 'select',
            options: [
              { value: 'ANYTIME', label: 'Anytime' },
              { value: 'AFTER_CONFIRMATION', label: 'After Confirmation' },
              { value: 'AFTER_3_MONTHS', label: 'After 3 Months' },
            ],
          },
        ],
      }}
    />
  );
}
